import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const ClientSideManagement = () => (
  <Section
    css={`
      @media screen and (min-width: ${getSize("tablet720")}) {
        justify-content: flex-end;
      }
    `}
  >
    <StaticQuery
      query={graphql`
        query ThermostatImageQuery {
          file(relativePath: { eq: "Thermostat.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 70% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 50% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize("desktop1920")}) {
          width: 582px;
        }
      `}
    >
      <Header2>
        Client-Side Management
        <Underlined />
      </Header2>
      <Paragraph>
        Savant Power provides utilities with cost effective, demand-side
        solutions including energy monitoring and management, smart thermostats,
        and other IoT enabled devices such as hot-water heaters. Load management
        can range from a single device to the entire electrical panel.
      </Paragraph>
    </Card>
  </Section>
);
